import { useEffect } from "react";
import { getBillingByPatient, updateBilling } from "../../../apis/billing";
import { toastify } from "../../../helperFunctions/toastify";
import _ from "lodash";
import { useState } from "react";
import FilterComponent from "../../SharedComponents/FilterComponent";
import DataTable from "react-data-table-component";
import { Accordion, Button, Modal, Table } from "react-bootstrap";
import DateInput from "../../SharedComponents/DateInput";
import { customArrayDateSort } from "../../../helperFunctions/utils";

export default function PackageDropdown({ patientId }) {
	const [packagesdata, setPackagesData] = useState([]);
	const [filteredData, setFilteredData] = useState([]);
	const [activeIndex, setActiveIndex] = useState();
	const [itemToEdit, setItemToEdit] = useState();
	const [openModal, setOpenModal] = useState(false);
	const [expiry, setExpiry] = useState();
	const [refetch, setRefetch] = useState(false);

	const onExpiryChange = async () => {
		if (!itemToEdit.billingId) {
			toastify("billing doen't exists", "error");
			return;
		}
		if (!expiry) {
			toastify("Expiry date is missing", "error");
			return;
		}
		const updatedPackages = itemToEdit?.billingPackages?.map((pack) => {
			if (pack?.package_id?._id == itemToEdit.id) {
				const currentExpiry =
					pack?.package_expiry?.length > 0
						? [...pack?.package_expiry]
						: [];
				currentExpiry.push(expiry);
				return {
					...pack,
					package_expiry: currentExpiry,
				};
			}
			return pack;
		});

		const data = {
			dataId: itemToEdit.billingId,
			package: updatedPackages,
		};
		const { result, error } = await updateBilling(data);
		if (error) {
			toastify("Failed to extend Package", "error");
			return;
		}
		toastify("Package extended successfuly", "success");
		setRefetch(!refetch);
		setItemToEdit();
		setExpiry();
		setOpenModal(false);
		setFilteredData([]);
		return;
	};

	const getStatusPackage = (item) => {
		const totalLimitProduct = item?.package_id?.products?.reduce(
			(acc, obj) => acc + obj.qty,
			0,
		);
		const totalLimitTreatment = item?.package_id?.treatments?.reduce(
			(acc, obj) => acc + obj.limit,
			0,
		);
		const totalUsedProduct = item?.products_used?.reduce(
			(acc, obj) => acc + obj.used,
			0,
		);
		const totalUsedTreatment = item?.treatments_used?.reduce(
			(acc, obj) => acc + obj.used,
			0,
		);

		if (
			totalLimitProduct + totalLimitTreatment ===
			totalUsedProduct + totalUsedTreatment
		) {
			return "Completed";
		} else if (new Date(item?.package_id?.expiredDate) < new Date()) {
			return "Expired";
		} else {
			return "Ongoing";
		}
	};

	useEffect(() => {
		if (patientId) {
			(async () => {
				const { result, error } = await getBillingByPatient(patientId);
				if (error) {
					toastify(error.message, "error");
					return;
				}
				let tempArr = result.map((pack) => {
					const loc = pack?.branch?.location?.find(
						(o) => o._id === pack?.location,
					)?.name;

					const packageDetails = pack?.package?.map((item) => {
						const expiry =
						customArrayDateSort(item?.package_expiry.length > 0
								? [
										item?.package_id?.expiredDate,
										...item?.package_expiry,
								  ]
								: [item?.package_id?.expiredDate]);
						const getMonthDif = (date2, date1) => {
							const dt_date1 = new Date(date1);
							const dt_date2 = new Date(date2);

							//Get the Timestamp
							const date1_time_stamp = dt_date1.getTime();
							const date2_time_stamp = dt_date2.getTime();

							let calc;

							//Check which timestamp is greater
							if (date1_time_stamp > date2_time_stamp) {
								calc = new Date(
									date1_time_stamp - date2_time_stamp,
								);
							} else {
								calc = new Date(
									date2_time_stamp - date1_time_stamp,
								);
							}
							//Retrieve the date, month and year
							const calcFormatTmp =
								calc.getDate() +
								"-" +
								(calc.getMonth() + 1) +
								"-" +
								calc.getFullYear();
							//Convert to an array and store
							const calcFormat = calcFormatTmp.split("-");
							//Subtract each member of our array from the default date
							const days_passed = Number(
								Math.abs(calcFormat[0]) - 1,
							);
							const months_passed = Number(
								Math.abs(calcFormat[1]) - 1,
							);
							const years_passed = Number(
								Math.abs(calcFormat[2]) - 1970,
							);

							//Set up custom text
							const yrsTxt = ["year", "years"];
							const mnthsTxt = ["month", "months"];
							const daysTxt = ["day", "days"];

							//Convert to days and sum together
							const total_days =
								years_passed * 365 +
								months_passed * 30.417 +
								days_passed;

							//display result with custom text
							const result =
								(years_passed == 1
									? years_passed + " " + yrsTxt[0] + " "
									: years_passed > 1
									? years_passed + " " + yrsTxt[1] + " "
									: "") +
								(months_passed == 1
									? months_passed + " " + mnthsTxt[0]
									: months_passed > 1
									? months_passed + " " + mnthsTxt[1] + " "
									: "") +
								(days_passed == 1
									? days_passed + " " + daysTxt[0]
									: days_passed > 1
									? days_passed + " " + daysTxt[1]
									: "");

							//return the result
							return result.trim();
						};

						let arrProduct = [];
						const packageProducts = item?.package_id?.products
							? [...item?.package_id?.products]
							: [];
						packageProducts.map((packageProduct) => {
							const productUsed = item?.products_used?.find(
								(x) => x.id === packageProduct.product?._id,
							);
							arrProduct.push({
								name: packageProduct.product?.name,
								qty: packageProduct.qty,
								unit_price:
									packageProduct.product?.unitSellingPrice,
								total_price:
									packageProduct.qty *
									packageProduct.product?.unitSellingPrice,
								used: productUsed ? productUsed.used : 0,
							});
						});

						let arrTreatment = [];
						const packageTreatments = item?.package_id?.treatments
							? [...item?.package_id?.treatments]
							: [];
						packageTreatments.map((packageTreatment) => {
							const treatmentUsed = item?.treatments_used?.find(
								(x) => x.id === packageTreatment.treatment?._id,
							);
							arrTreatment.push({
								name: packageTreatment.treatment?.name,
								qty: packageTreatment.limit,
								unit_price: packageTreatment.treatment?.price,
								total_price:
									packageTreatment.limit *
									packageTreatment.treatment?.price,
								used: treatmentUsed ? treatmentUsed.used : 0,
							});
						});

						return {
							id: item?.package_id?._id,
							billingId: pack?._id,
							billingPackages: pack?.package,
							name: item?.package_id?.name,
							products: arrProduct,
							treatments: arrTreatment,
							effectiveDate: new Date(
								item?.package_id?.effectiveDate,
							).toLocaleDateString(),
							expiryDuration: getMonthDif(
								new Date(item?.package_id?.effectiveDate),
								new Date(expiry[expiry.length - 1]),
							),
							totalItemPrice: item?.package_id?.totalCost,
							totalSellingPrice: item?.package_id?.totalPrice,
							code: item?.package_id?.code,
							location: loc,
							purchaseDate: new Date(
								pack?.created_at,
							).toLocaleDateString(),
							allExpiry: expiry,
							expiredDate: (
								<>
									{expiry.length > 0 &&
										expiry.map((exp) => {
											return (
												<div>
													{new Date(
														exp,
													).toLocaleDateString()}
												</div>
											);
										})}
								</>
							),
							status:
								new Date(expiry[expiry.length - 1]).getTime() <
								new Date().getTime()
									? false
									: true,
						};
					});
					return [...packageDetails];
				});
				tempArr = _.flattenDeep(tempArr);

				tempArr = tempArr.map((o, idx) => {
					const otherPurchases = tempArr.filter(
						(k, i) => k.id == o.id && idx !== i,
					);
					return {
						...o,
						otherPurchases,
					};
				});

				setPackagesData([...tempArr]);
			})();
		}
	}, [patientId, refetch]);

	return (
		<>
			<div className="p-0">
				<div className="grey mb-2 ps-3" style={{ fontSize: "16px" }}>
					Total Count:{packagesdata?.length}
				</div>
				<Table striped>
					<thead
						style={{
							background: "#34556F",
							color: "white",
						}}
					>
						<tr
							style={{
								height: "45px",
							}}
							className="align-items-center
							"
						>
							<th className="wd-100 ">
								<span className="me-2 ps-2">Name</span>
								<FilterComponent
									type="search"
									array={packagesdata}
									setArray={setFilteredData}
									value={"name"}
								/>{" "}
							</th>
							<th className="wd-100">
								<span className="me-2">Effective Date</span>
								{/* <FilterComponent
									type="search"
									array={packagesdata}
									setArray={setFilteredData}
									value={"name"}
								/> */}
							</th>
							<th className="wd-100">Expiry Date</th>
							<th className="wd-100">Total Item Price</th>
							<th className="wd-100">Total Selling Price</th>
							<th className="wd-100">Status</th>
							<th className="wd-100">Action</th>
						</tr>
					</thead>
					<tbody>
						{(filteredData.length === 0
							? packagesdata
							: filteredData
						)?.map((e, index) => (
							<>
								<tr>
									<td className="wd-150 ps-3">{e.name}</td>
									<td className="wd-150 ps-3">
										{e.effectiveDate}
									</td>
									<td className="wd-100">{e.expiredDate}</td>
									<td className="wd-100">
										{e.totalItemPrice}
									</td>
									<td className="wd-100">
										{e.totalSellingPrice}
									</td>
									<td className="wd-150 pe-5">
										{e.status === "Completed" && (
											<div
												className="active-status"
												style={{ maxWidth: "50px" }}
											>
												Completed
											</div>
										)}

										{e.status && (
											<div
												className="ongoing-status"
												style={{ maxWidth: "50px" }}
											>
												On Going
											</div>
										)}

										{!e.status && (
											<div
												className="inactive-status"
												style={{ maxWidth: "50px" }}
											>
												Expired
											</div>
										)}
									</td>
									<td className="wd-100 ">
										<div className="d-flex">
											<i
												class="fa-regular fa-eye align-self-center me-3"
												onClick={() => {
													if (activeIndex == index) {
														setActiveIndex();
														return;
													}
													setActiveIndex(index);
												}}
											></i>
											<Button
												className="addItem"
												style={{
													maxHeight: "35px",
													width: "100px",
													fontWeight: 400,
													fontSize: "14px",
												}}
												onClick={() => {
													setItemToEdit(e);
													setOpenModal(true);
													setExpiry(
														e?.allExpiry[
															e?.allExpiry
																?.length - 1
														],
													);
													// if (activeIndex == index) {
													// setActiveIndex();
													// return;
													// }
													// setActiveIndex(index);
												}}
											>
												Extend
											</Button>
										</div>
									</td>
								</tr>
								{activeIndex === index && (
									<tr>
										<td
											colSpan="12"
											style={{
												backgroundColor: "#f2f2f2",
												padding: "20px",
											}}
										>
											<Table>
												<thead
													style={{
														background: "#34556F",
														color: "white",
														width: "100%",
													}}
												>
													<tr
														style={{
															height: "45px",
														}}
														className="align-items-center"
													>
														<th className="wd-150">
															<span className="me-2 ps-2">
																Type
															</span>
														</th>
														{/* <th className="wd-150">
																Code
														</th> */}
														<th className="wd-150">
															Name
														</th>
														<th className="wd-150">
															Limit
														</th>
														<th className="wd-150">
															Used
														</th>
														<th className="wd-150">
															Unit Price
														</th>
														<th className="wd-150">
															Amount
														</th>
													</tr>
												</thead>
												<tbody>
													{e.products?.length > 0 &&
														e?.products?.map(
															(
																product,
																productIndex,
															) => {
																return (
																	<tr
																		key={
																			productIndex
																		}
																	>
																		<td>
																			Product
																		</td>
																		<td>
																			{
																				product.name
																			}
																		</td>
																		<td>
																			{
																				product.qty
																			}
																		</td>
																		<td>
																			{
																				product.used
																			}
																		</td>
																		<td>
																			{
																				product.unit_price
																			}
																		</td>
																		<td>
																			{
																				product.total_price
																			}
																		</td>
																	</tr>
																);
															},
														)}
													{e.treatments?.length > 0 &&
														e?.treatments?.map(
															(
																product,
																productIndex,
															) => {
																return (
																	<tr
																		key={
																			productIndex
																		}
																	>
																		<td>
																			Treatment
																		</td>
																		<td>
																			{
																				product.name
																			}
																		</td>
																		<td>
																			{
																				product.qty
																			}
																		</td>
																		<td>
																			{
																				product.used
																			}
																		</td>
																		<td>
																			{
																				product.unit_price
																			}
																		</td>
																		<td>
																			{
																				product.total_price
																			}
																		</td>
																	</tr>
																);
															},
														)}
												</tbody>
											</Table>
										</td>
									</tr>
								)}
							</>
						))}
					</tbody>
				</Table>
			</div>
			<Modal
				centered
				show={openModal}
				onHide={() => {
					setOpenModal(!openModal);
				}}
			>
				<Modal.Header closeButton>
					<b>Extend Package Expiry Date</b>
				</Modal.Header>
				<Modal.Body>
					<div>
						<span>
							<b> Expiry *</b>
						</span>
						<DateInput
							// label={"Visit Date:"}
							className="mt-3"
							value={expiry}
							placeholder="Expiry Date"
							onChange={(e) => {
								setExpiry(e);
							}}
						/>
						<Button
							className="addItem"
							onClick={() => {
								onExpiryChange();
							}}
						>
							Save
						</Button>
					</div>
				</Modal.Body>
			</Modal>
		</>
	);
}
